/* unplugin-vue-components disabled */import script from "./menu-toggler.vue?vue&type=script&lang=ts&setup=true"
export * from "./menu-toggler.vue?vue&type=script&lang=ts&setup=true"

import "./menu-toggler.vue?vue&type=style&index=0&id=2bf961be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf961be"]])

export default __exports__